import { adminApiFetch } from './apiService';

export const shippingTypeService = {
  index: async () => {
    const response = await adminApiFetch('shipping_types');
    return response.json();
  },
  getRecords: async (params) => {
    const response = await adminApiFetch('shipping_types/get_records', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },
  getIds: async (params) => {
    const response = await adminApiFetch('shipping_types/get_ids', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },
  // 取得系統物流目錄（含啟用狀態）——供 ShippingAccount 表單勾選 shipping_type_codes 使用。
  catalog: async () => {
    try {
      const response = await adminApiFetch('shipping_types/catalog');
      if (!response.ok) throw new Error('Failed to fetch shipping type catalog');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  }
};

export default shippingTypeService;
